<template>
  <section>
    <el-row class="content-top">
      <el-button
        @click="add = true"
        type="primary">
        <i class="el-icon-plus"></i>
        {{ $t('pages.hamlet_users.add_user') }}
      </el-button>
    </el-row>
    <el-row v-loading="pageLoading">
      <el-table :data="users">
        <el-table-column
          prop="id"
          width="100"
          :label="$t('pages.hamlet_users.id')">
        </el-table-column>
        <el-table-column
          prop="username"
          width="130"
          :label="$t('pages.hamlet_users.username')">
        </el-table-column>
        <el-table-column
          prop="email"
          min-width="150"
          :label="$t('pages.hamlet_users.email')">
        </el-table-column>
       <!--  <el-table-column prop="role" :label="$t('pages.hamlet_users.role')">
         <template slot-scope="scope">
           {{scope.row.role === 'root' ? $t('common.admin') : $t('common.user')}}
         </template>
       </el-table-column> -->
        <el-table-column
          min-width="150"
          :label="$t('pages.hamlet_users.applications')"
          :formatter="joinAppsName">
        </el-table-column>
        <el-table-column
          prop="last_login_at"
          width="160"
          align="center"
          :label="$t('pages.hamlet_users.last_login_at')"
          :formatter="formatDatetime">
        </el-table-column>
        <el-table-column
          prop="status"
          width="120"
          align="center"
          :label="$t('pages.hamlet_users.status')">
          <template slot-scope="scope">
            {{ scope.row.status }}
          </template>
        </el-table-column>
        <el-table-column
          prop="thirdparty_users"
          min-width="100"
          :label="$t('pages.hamlet_users.thirdparty_users')">
          <template slot-scope="scope">
            <el-popover
              v-for="type in Object.keys(scope.row.thirdparty_users)"
              :key="type"
              placement="right"
              trigger="click">
              <el-button
                type="text"
                :key="type"
                slot="reference">
                {{ $t('common.' + type) }}
              </el-button>
              <pre>{{ scope.row.thirdparty_users[type] }}</pre>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('common.operation')"
          min-width="100"
          align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="editUserApps(scope.row)">
              {{ $t('common.edit') }}
            </el-button>
            <el-button
              type="text"
              @click="resetPassword(scope.row)">
              {{ $t('common.resetPassword') }}
            </el-button>
            <el-button
              type="text"
              @click="activeUser(scope.row)"
            >
              {{ $t(`common.${scope.row.is_active ? 'forbid' : 'active'}`) }}
            </el-button>
            <el-button
              type="text"
              @click="unlockUser(scope.row.id)"
              v-if="scope.row.is_locked"
            >
              {{ $t('common.unlock') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <!-- edit user -->
    <el-dialog v-model="edit" :title="$t('common.edit')">
      <el-form :model="userApps" label-width="100px">
        <el-form-item :label="$t('pages.hamlet_users.username')">
          {{ userApps.username }}
        </el-form-item>
        <el-form-item :label="$t('pages.hamlet_users.applications')">
          <el-checkbox-group
            v-if="apps.length"
            v-model="userApps.app_ids">
            <el-checkbox
              v-for="app in apps"
              :label="app.id"
              :key="app.id"
              v-if="app.name !== 'Hamlet'">
              {{ app.name }}
            </el-checkbox>
          </el-checkbox-group>
          <p v-else>
            {{ $t('pages.hamlet_users.no_apps') }}
          </p>
        </el-form-item>
        <el-form-item>
          <el-button
            @click="authorizeAppManager"
            type="primary">
            {{ $t('common.save') }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- add user -->
    <el-dialog
      v-model="add"
      @close="resetAdd"
      :title="$t('pages.hamlet_users.add_user')">
      <el-form
        :model="addUser"
        ref="addForm"
        :rules="addUserRules"
        label-width="100px">
        <el-form-item
          :label="$t('common.username')"
          prop="username">
          <el-input
            v-model="addUser.username"
            @blur="checkUsername"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('common.email')"
          prop="email">
          <el-input
            v-model="addUser.email"
            @blur="checkEmail"></el-input>
        </el-form-item>
        <template v-if="!usernameIsExist && !emailIsExist">
          <el-form-item
            :label="$t('common.password')"
            prop="password">
            <el-input v-model="addUser.password"></el-input>
              <el-row class="random-psw">
                <el-button
                  type="text"
                  @click="createRandomPassword()">
                  {{ $t('common.random_password') }}
                </el-button>
                <code>{{this.randomPassword}}</code>
              </el-row>
          </el-form-item>
          <el-form-item
            :label="$t('common.confirmPassword')"
            prop="confirm_password">
            <el-input
              v-model="addUser.confirm_password"
              @keyup.enter.native="submitAddUser"></el-input>
          </el-form-item>
        </template>
        <el-form-item>
          <el-button
            @click="submitAddUser"
            :disabled="!this.addUser.username && !this.addUser.email"
            type="primary">
            {{ $t('common.save') }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- reset password -->
    <el-dialog
      v-model="reset"
      @close="resetPasswordForm"
      :title="$t('common.resetPassword')">
      <el-form
        :model="userReset"
        ref="resetForm"
        :rules="resetPasswordRules"
        label-width="100px">
        <el-form-item
          :label="$t('common.username')"
          prop="username" >
          {{ userReset.username }}
        </el-form-item>
        <el-form-item
          :label="$t('common.password')"
          prop="password">
          <el-input
            v-model="userReset.password"
            type="password"></el-input>
          <el-row class="random-psw">
            <el-button
              type="text"
              @click="createRandomPassword()">
              {{ $t('common.random_password') }}
            </el-button>
            <code>{{ this.randomPassword }}</code>
          </el-row>
        </el-form-item>
        <el-form-item
          :label="$t('common.confirmPassword')"
          prop="confirm_password">
          <el-input
            v-model="userReset.confirm_password"
            type="password"
            @keyup.enter.native="submitResetPassword"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            @click="submitResetPassword"
            type="primary">
            {{ $t('common.save') }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </section>
</template>

<script>
  import { compareIgnoreCase } from '@/utils/index';

  export default {
    name: 'HamletUsers',
    data() {
      /* eslint-disable */
      const ptn = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const stringValidator = (rule, value, cb) => {
        if (!value || value.trim() === '') {
          cb();
        } else if (this.users.find(user => user.username === value)) {
          cb(new Error(this.$t('rules.has_username')));
        } else if (this.addUser.email && this.originalUsername !== '' &&
          this.addUser.username !== this.originalUsername) {
          if (!this.originalUsername) {
            cb(new Error(this.$t('pages.hamlet_users.usernameIsEmpty')));
          }

          cb(new Error(this.$t('pages.hamlet_users.usernameNotMatch', { name: this.originalUsername })));
        } else {
          cb();
        }
      };
      const emailValidator = (rule, value, cb) => {
        if (!value || value.trim() === '') {
          cb();
        } else if (this.addUser.username && this.originalEmail !== '' &&
          this.addUser.email !== this.originalEmail) {
          if (!this.originalEmail) {
            cb(new Error(this.$t('pages.hamlet_users.emailIsEmpty', { username: this.addUser.username })));
          }

          cb(new Error(this.$t('pages.hamlet_users.emailNotMatch', { name: this.originalEmail })));
        } else if (!this.emailRegexp.test(value)) {
          cb(new Error(this.$t('rules.email')));
        } else if (this.users.find(user => user.email === value)) {
          cb(new Error(this.$t('rules.has_email')));
        } else {
          cb();
        }
      };
      const pwValidator = (rule, value, cb) => {
        const ptn = this.$consts.PASSWORD_REGEXP;
        if (value.trim() === '') {
          cb(new Error(this.$t('common.passwordPlaceholder')));
        } else if (!ptn.test(value)) {
          cb(new Error(this.$t('rules.password_format')));
        } else {
          cb();
        }
      };
      const pwConfirmValidator = (rule, value, cb) => {
        let form;
        if (this.add) form = 'addUser';
        if (this.reset) form = 'userReset';
        if (value.trim() === '') {
          cb(new Error(this.$t('common.passwordPlaceholder')));
        } else if (form.length && value !== this[form].password) {
          cb(new Error(this.$t('rules.password_repeat')));
        } else {
          cb();
        }
      };

      return {
        pageLoading: false,
        emailRegexp: ptn,
        randomPassword: '',
        users: [],
        apps: [],
        edit: false,
        add: false,
        reset: false,
        userApps: {
          id: '',
          username: '',
          app_ids: [],
        },
        addUser: {
          username: '',
          email: '',
          password: '',
          confirm_password: '',
        },
        usernameIsValid: false,

        // 用户名在系统中已存在，此时不需要输入密码
        usernameIsExist: false,
        originalUsername: '',
        emailIsValid: false,

        // 邮箱在系统中已存在
        emailIsExist: false,
        originalEmail: '',
        userReset: {
          username: '',
          id: '',
          password: '',
          confirm_password: '',
        },
        addUserRules: {
          username: [
            { required: false,  validator: stringValidator },
          ],
          email: [
            { required: false, validator: emailValidator }
          ],
          password: [
            { required: true, validator: pwValidator },
          ],
          confirm_password: [
            { required: true, validator: pwConfirmValidator },
          ],
        },
        resetPasswordRules: {
          password: [
            { required: true, validator: pwValidator },
          ],
          confirm_password: [
            { required: true, validator: pwConfirmValidator },
          ],
        },
      };
    },
    watch: {
      /* eslint-disable object-shorthand */
      'addUser.username'(newVal, oldVal) {
        if (newVal && oldVal) {
          this.originalEmail = '';
          this.$refs.addForm.validateField('email');
        }
      },
      'addUser.email'(newVal, oldVal) {
        if (newVal && oldVal) {
          this.originalUsername = '';
          this.$refs.addForm.validateField('username');
        }
      },
    },
    methods: {
      resetAdd() {
        this.clearPassword();
        this.$refs.addForm.resetFields();
        this.usernameIsValid = false;
        this.usernameIsExist = false;
        this.emailIsValid = false;
        this.emailIsExist = false;
        this.originalUsername = '';
        this.originalEmail = '';
      },
      resetPasswordForm() {
        this.clearPassword();
        this.$refs.resetForm.resetFields();
      },
      createRandomPassword() {
        this.randomPassword = this.$utils.randomPassword();
        this.addUser.password = this.randomPassword;
        this.addUser.confirm_password = this.randomPassword;
        this.userReset.password = this.randomPassword;
        this.userReset.confirm_password = this.randomPassword;
      },
      clearPassword() {
        this.randomPassword = '';
      },
      formatDatetime(r, c) {
        const ds = r[c.property];
        return ds ? this.$moment(ds).utcOffset(+960).format('YYYY/M/DD HH:mm:ss') : '';
      },
      joinAppsName(row) {
        return row.applications.map(app => app.name).join(',');
      },
      fetchHamletUsers() {
        this.$api.fetchHamletUsers().then((res) => {
          const cleaningRecords = [];
          for (let i = 0, len = res.data.users.length; i < len; i += 1) {
            const record = Object.assign({}, res.data.users[i]);  // copy object. avoid vuex outside change error
            if (!record.is_active) {
              record.status = this.$t('pages.hamlet_users.inactive');
            } else if (record.is_locked) {
              record.status = this.$t('pages.hamlet_users.locked');
            } else {
              record.status = this.$t('pages.hamlet_users.normal');
            }
            record.username = record.username || '';  // 方便搜索、排序  部分用户名字为空
            record.email = record.email || '';  // 方便搜索、排序
            cleaningRecords.push(record);
          }
          this.users = cleaningRecords;
        });
      },
      fetchApps() {
        this.pageLoading = true;
        this.$api.listApps()
          .then((res) => {
            this.apps = res.data.applications;
          })
          .finally(() => {
            this.pageLoading = false;
          });
      },
      addHamletUser() {
        this.$api.addHamletUser(this.addUser)
          .then((res) => {
            this.add = false;
            this.fetchHamletUsers();
          })
          .catch((res) => {
            console.log('res', res);
            this.$message,error(this.$t('common.addFailed'));
          });
      },
      authorizeAppManager() {
        this.$api.authorizeAppManager(this.userApps.id,
          {
            app_ids: this.userApps.app_ids,
          }).then((res) => {
            this.edit = false;
            this.fetchHamletUsers();
          });
      },
      changeUserPassword() {
        this.$api.changeUserPassword(this.userReset.id, {
          password: this.userReset.password,
          confirm_password: this.userReset.confirm_password,
        }).then((val) => {
          this.reset = false;
        }).catch((res) => {
          // console.log('>>>changeUserPassword failed>>>', res);
          this.$message.error(res.body.reason);
        });
      },
      editUserApps(row) {
        Object.assign(this.userApps, {
          id: row.id,
          username: row.username,
          app_ids: row.applications.map(app => app.id),
        });
        this.edit = true;
      },
      editUser(id, param) {
        this.$api.editUser(id, param).then((res) => {
          this.fetchHamletUsers();
        }).catch(res=>{
          if(res.data.err_code === "01A0106"){
            console.log(1);
            this.$message.error('该用户已被停用，如需启用，请先前往Hamlet 2的Hamlet 1用户管理界面启用');
          }
        });
      },
      unlockUser(id) {
        this.$api.unlockUser(id).then((res) => {
          this.fetchHamletUsers();
        });
      },
      resetPassword(row) {
        Object.assign(this.userReset, {
          username: row.username,
          id: row.id,
        });
        this.reset = true;
      },
      submitAddUser() {
        this.$nextTick(() => {
          this.$refs.addForm.validate((validate) => {
            if (validate) {
              this.$api.userIsExist({
                username: this.addUser.username,
                email: this.addUser.email,
              }).then(() => {
                this.usernameIsExist = false;
                this.emailIsExist = false;
                this.$nextTick(() => {
                  this.$refs.addForm.validate((validate) => {
                    if (validate) {
                      this.addHamletUser();
                    }
                  });
                });
              }).catch((res) => {
                const data = res.body.data;
                this.$nextTick(() => {
                  if ((!this.addUser.username || data.user.username ===  this.addUser.username) &&
                    (!this.addUser.email || !compareIgnoreCase(data.user.email, this.addUser.email))) {
                    this.addHamletUser();
                  }
                });
              });
            }
          });
        });
      },
      submitResetPassword() {
        this.$refs.resetForm.validate((validate) => {
          if (validate) {
            this.changeUserPassword();
          }
        });
      },
      unlockUserWithWarning(row) {
        this.$msgbox.confirm(this.$t('verify.unlock_user', {'username': row.username}), this.$t('common.unlock'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
        }).then(() => {
          this.unlockUser(row.id);
        });
      },
      activeUser(row) {
        const message = row.is_active ? 'verify.forbid_user' : 'verify.active_user';
        const title = row.is_active ? 'common.forbid' : 'common.active';
        this.$msgbox.confirm(this.$t(message, {'username': row.username}), this.$t(title), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
        }).then(() => {
          this.editUser(row.id, { is_active: !row.is_active });
        });
      },
      checkUsername() {
        this.usernameIsValid = !!(this.addUser.username && !this.users.find(user => user.username === this.addUser.username));
        if (!this.usernameIsValid) {
          // this.originalUsername = '';
          this.originalEmail = '';
          this.usernameIsExist = false;
        }

        this.$refs.addForm.validateField('username');
        this.$refs.addForm.validateField('email');
        if (this.usernameIsValid) {
          this.$api.userIsExist({
            username: this.addUser.username,
          })
          .then((val) => {
            this.usernameIsExist = false;
            this.originalEmail = '';
          })
          .catch((res) => {
            console.log('res', res.body.data);
            const data = res.body.data;

            // this.originalUsername = data.user.username;
            this.originalEmail = data.user.email;

            // 仅邮箱为空时，自动填充
            if (!this.addUser.email || !compareIgnoreCase(data.user.email, this.addUser.email)) {
              this.addUser.email = data.user.email;
              this.emailIsValid = true;
              this.emailIsExist = true;
            }

            this.usernameIsExist = true;
          })
          .finally(() => {
            // this.$refs.addForm.validateField('email');
            this.$refs.addForm.validate();
          });
        }
      },
      checkEmail() {
        this.emailIsValid = !!(this.addUser.email &&
          this.emailRegexp.test(this.addUser.email) &&
          !this.users.find(user => user.email === this.addUser.email));
        if (!this.emailIsValid) {
          // this.originalEmail = '';
          this.originalUsername = '';
          this.emailIsExist = false;
        }

        this.$refs.addForm.validateField('username');
        this.$refs.addForm.validateField('email');
        if (this.emailIsValid) {
          this.$api.userIsExist({
            email: this.addUser.email,
          })
          .then(() => {
            this.emailIsExist = false;
            this.originalUsername = '';
          })
          .catch((res) => {
            const data = res.body.data;

            this.originalUsername = data.user.username;
            // this.originalEmail = data.user.email;

            // 仅邮箱为空时，自动填充
            if (!this.addUser.username ||
              (data.user.username === this.addUser.username)) {
              this.addUser.username = data.user.username;
              this.usernameIsValid = true;
              this.usernameIsExist = true;
            }

            this.emailIsExist = true;
          })
          .finally(() => {
            this.$refs.addForm.validate();
          });
        }
      },
    },
    created() {
      this.fetchHamletUsers();
      this.fetchApps();
    },
  };
</script>



// WEBPACK FOOTER //
// HamletUsers.vue?6c30bd98